module.exports = __webpack_public_path__ + "img/12.37211003.jpg";